import React, { useState } from "react";
import "./feedback-modal.css";
import { IoClose } from "react-icons/io5";
import { showToast } from "../toasts/ToastNotification";
import { createNewReview } from "../../api/review.api";
import { ClipLoader } from "react-spinners";
import { FiMessageSquare } from "react-icons/fi";

const FeedbackModal = ({ isOpen, onClose, productId, orderId, setIsReviewed, setOrder }) => {
  const [rating, setRating] = useState(0);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState(null);

  const handleRating = (val) => {
    setRating(val);
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);

    if (message.trim() === "") {
      setError({ message: "Không được để trống đánh giá" });
      setLoading(false);
      return;
      }
      
      if (message.trim().length > 100) {
        setError({ message: "Đánh giá tối đa là 100 ký tự" });
        setLoading(false);
        return;
      } else if (message.trim().length < 20) {
        setError({ message: "Đánh giá tối thiểu là 20 ký tự" });
        setLoading(false);
        return;
    }
    
    if (rating <= 0) {
      setError({ message: "Vui lòng chọn số sao" });
      setLoading(false);
      return;
    }
    
    try {
      const res = await createNewReview(
        productId,
        orderId,
        rating,
        message
      );

      if (res.success) {
        setIsReviewed(true);
        setOrder((prev) => ({
          ...prev,
          review: res.data.newReview
        }));
        showToast("Đánh giá thành công", "success");
        onClose();
      }
    } catch (error) {
      showToast(error.message, "error");
    }
    finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fdm-overlay">
      <div className="fdm-card">
        <div className="fdm-header">
          <div className="fdm-title-wrap">
            <FiMessageSquare className="fdm-title-icon" />
            <h2 className="fdm-title">Đánh giá đơn hàng</h2>
          </div>
          <button className="fdm-close-btn" onClick={onClose} type="button" aria-label="Đóng modal">
            <IoClose />
          </button>
        </div>

        <p className="fdm-subtitle">Chọn số sao và chia sẻ trải nghiệm của bạn sau khi nhận sản phẩm.</p>

        <div className="fdm-rating-wrap">
          {[1, 2, 3, 4, 5].map((star) => (
            <button
              type="button"
              key={star}
              className={`fdm-star ${rating >= star ? "active" : ""}`}
              onClick={() => handleRating(star)}
              aria-label={`${star} sao`}
            >
              ★
            </button>
          ))}
          <span className="fdm-rating-label">{rating > 0 ? `${rating}/5 sao` : "Chưa chọn sao"}</span>
        </div>

        <textarea
          className="fdm-textarea"
          placeholder="Hãy để lại trải nghiệm của bạn về đơn hàng..."
          value={message}
          minLength="20"
          maxLength="100"
          required
          onChange={(e) => setMessage(e.target.value)}
        />
        <p className="fdm-char-count">{message.length} / 100 ký tự</p>
        {error && (
          <p className="fdm-error-message">*{error?.message}</p>
        )}
        <button disabled={loading} className="fdm-submit-btn" onClick={handleSubmit} type="button">
          {loading ? <ClipLoader size={20} color="#fff"/> : "Gửi đánh giá"}
        </button>
      </div>
    </div>
  );
};

export default FeedbackModal;
